import { svg } from 'lit';
export const check24Svg = svg `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M19.5 6L9 16.5L4.5 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
//# sourceMappingURL=check_24.svg.js.map